import type { UseFormReturn } from 'react-hook-form';

import { MetricUrls } from './components/MetricUrls';
import type { MetricForm } from './formUtils';
import { MetricDefinitionFormField } from './MetricDefinitionFormField';

interface PageviewMetricDetailsProps {
  context: UseFormReturn<MetricForm>;
}

export const PageviewMetricDetails: React.FC<PageviewMetricDetailsProps> = ({ context }) => (
  <>
    <MetricUrls context={context} />
    <MetricDefinitionFormField context={context} />
  </>
);
